export const symbolsCountSelectOptions = [
	{ title: 'По умолчанию...', value: '3000' },
	{ title: '200', value: '200' },
	{ title: '400', value: '400' },
	{ title: '600', value: '600' },
	{ title: '800', value: '800' },
	{ title: '1200', value: '1200' },
	{ title: '1800', value: '1800' },
];
